// src/pages/SubtypeList.js
import React, { useEffect, useState } from "react";
import { useAuthCheck } from "../components/Auth";
import { api } from "../components/Api";
import Loading from "../components/Loading";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";

export default function SubtypeList() {
    const [subtypes, setSubtypes] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const { checkToken } = useAuthCheck();

    useEffect(() => { checkToken(); }, [checkToken]);

    useEffect(() => {
        fetchSubtypes();
    }, []);

    const fetchSubtypes = async () => {
        setLoading(true);
        try {
            const res = await api.get("/subtypes");
            setSubtypes(res.data);
        } catch (err) {
            console.error(err);
            alert("Erreur lors de la récupération des sous-types.");
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async (id) => {
        if (!window.confirm("Voulez-vous vraiment supprimer ce sous-type ?")) return;

        try {
            await api.delete(`/subtypes/${id}`);
            alert("Sous-type supprimé avec succès.");
            setSubtypes((prev) => prev.filter((s) => s.id !== id));
        } catch (err) {
            console.error(err);
            if (err.response?.status === 409) {
                alert("Impossible de supprimer ce sous-type car il est utilisé par des produits.");
            } else {
                alert("Erreur lors de la suppression du sous-type.");
            }
        }
    };

    const token = localStorage.getItem("token");

    if (!token || localStorage.getItem("role") > 2) {
        navigate("/");
    }

    return (
        <div className="container mx-auto p-6">
            <h1 className="text-2xl font-bold mb-4 dark:text-white">Liste des Sous-Types</h1>

            <button
                onClick={() => navigate("/add-subtype")}
                className="bg-blue-400 hover:bg-blue-500 text-white font-semibold rounded px-4 py-2 mb-4"
            >
                Ajouter un sous-type
            </button>

            {loading ? (
                <Loading message="Chargement des sous-types..." />
            ) : (
                <div className="overflow-x-auto">
                    <table className="w-full border-collapse border text-sm text-center">
                        <thead className="bg-gray-100 dark:bg-gray-800">
                            <tr>
                                <th className="border px-2 py-1">Type</th>
                                <th className="border px-2 py-1">Sous-Type</th>
                                <th className="border px-2 py-1">Référence</th>
                                <th className="border px-2 py-1">Supprimer</th>
                            </tr>
                        </thead>
                        <tbody>
                            {subtypes.map((subtype, index) => {
                                const bgColor = index % 2 === 0 ? "dark:bg-gray-600 bg-gray-050" : "dark:bg-gray-700 bg-gray-100";
                                return (
                                    <tr key={subtype.id} className={`${bgColor}`}>
                                        <td className="border px-2 py-1">{subtype.type?.type_name || ""}</td>
                                        <td className="border px-2 py-1">{subtype.subtype_name}</td>
                                        <td className="border px-2 py-1">{subtype.subtype_ref}</td>
                                        <td className="border px-2 py-1">
                                            <button
                                                onClick={() => handleDelete(subtype.id)}
                                                className="text-red-500 hover:text-red-700 text-2xl"
                                            >
                                                <FontAwesomeIcon icon={faTrashCan} />
                                            </button>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
}
